import { OFFER_PARTS, offerPart, type OfferPart, type OfferPartSettings } from "@/lib/offer-parts";

export function OfferPartSelect({ value, onChange, label, settings }: {
  value?: OfferPart; onChange: (part: OfferPart) => void; label: string; settings?: OfferPartSettings;
}) {
  return <select aria-label={label} title={label} value={offerPart(value)}
    className="h-7 rounded border border-input bg-background px-1 text-xs"
    onChange={(event) => onChange(event.target.value as OfferPart)}>
    {OFFER_PARTS.map((part) => <option key={part} value={part}>{settings?.[part].title ?? `Teil ${part}`}</option>)}
  </select>;
}
